var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1C2233"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4257 24.39H22.8119C23.2178 24.39 23.5545 24.05 23.5545 23.64C23.5545 23.23 23.2178 22.9 22.8119 22.9H17.4257C17.0198 22.9 16.6832 23.23 16.6832 23.64C16.6832 24.05 17.0198 24.39 17.4257 24.39ZM20.7723 17.9H17.4257C17.0198 17.9 16.6832 18.24 16.6832 18.65C16.6832 19.06 17.0198 19.39 17.4257 19.39H20.7723C21.1782 19.39 21.5149 19.06 21.5149 18.65C21.5149 18.24 21.1782 17.9 20.7723 17.9ZM27.8381 17.0256C28.0708 17.0229 28.3242 17.02 28.5545 17.02C28.802 17.02 29 17.22 29 17.47V25.51C29 27.99 27.0099 30 24.5545 30H16.6733C14.099 30 12 27.89 12 25.29V14.51C12 12.03 14 10 16.4653 10H21.7525C22.0099 10 22.2079 10.21 22.2079 10.46V13.68C22.2079 15.51 23.703 17.01 25.5149 17.02C25.9381 17.02 26.3112 17.0232 26.6377 17.0259C26.8917 17.0281 27.1175 17.03 27.3168 17.03C27.4578 17.03 27.6405 17.0279 27.8381 17.0256ZM28.1111 15.566C27.2972 15.569 26.3378 15.566 25.6477 15.559C24.5527 15.559 23.6507 14.648 23.6507 13.542V10.906C23.6507 10.475 24.1685 10.261 24.4646 10.572C25.0004 11.1348 25.7368 11.9083 26.4699 12.6784C27.2009 13.4463 27.9286 14.2107 28.4507 14.759C28.7398 15.062 28.5279 15.565 28.1111 15.566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon (1).b92e42abbfe6b58508ccf0855872d9e9.svg";
export { ForwardRef as ReactComponent };